// 复制到剪切板
export default {
	install(Vue) {
		// main.js
		Vue.prototype.$copyText = async function (value) {
			// 检查是否为空值（null、undefined、空字符串、纯空格）
			if (value === null || value === undefined || value === "") {
				// this.$message.warning("内容为空，未复制");
				return;
			}
			try {
				if (navigator.clipboard) {
					await navigator.clipboard.writeText(value.toString().trim());
					this.$message.success("复制成功");
				} else {
					this.$fallbackCopy(value);
				}
			} catch (err) {
				console.error("复制失败:", err);
				this.$fallbackCopy(value);
			}
		};

		Vue.prototype.$fallbackCopy = function (text) {
			const textarea = document.createElement("textarea");
			textarea.value = text;
			textarea.style.opacity = "0"; // 隐藏元素
			document.body.appendChild(textarea);
			textarea.select();
			try {
				document.execCommand("copy");
				this.$message.success("复制成功");
			} catch {
				this.$message.error("请手动复制（Ctrl+C）");
			} finally {
				document.body.removeChild(textarea);
			}
		};
	},
};
